import { Form } from "@components";
import React from "react";
import { VIP } from "../../../../../../store";
import Hooks from "@hooks";
import { messages } from "../../../../../request/steps/user-information/views/users-list/add-user-modal/messages";

interface Props {
  data: VIP | undefined;
  onHandleChange: (key: any, any: any) => void;
  form: any;
}

type FormValues = {
  id: number;
  vipEmail: string;
  isVoid: boolean;
  isActive: boolean;
  approverEmail: string;
};

type Data = {
  has_started: "yes" | "no";
};

type Key = keyof FormValues;

export const FormData: React.FC<Props> = ({ data, onHandleChange, form }) => {
  const [directory_approverEmails, , directory_approverEmails_fetching] = Hooks.useDirectory(
    form.values.approverEmail
  );
  const [approverEmail, approverEmail_error, approverEmail_fetching] = Hooks.useUserID(
    form.values.approverEmail
  );
  const [message, setMessage] = React.useState<{
    text: string;
    error?: boolean;
  }>({
    text: messages.has_started,
  });
  const prev = {
    form_errors: Hooks.usePrevious(form.errors),
    form_values: Hooks.usePrevious(form.values),
    approverEmail_fetching: Hooks.usePrevious(approverEmail_fetching),
  };

  function handleApproverEmailValueInput(name: string, value: string): void {
    form.set(Form.target.VALUE, ["approverEmail", value]);
  }

  function handleMessage(error: any) {
    setMessage({
      text: !!error
        ? messages.form_has_errors
        : form.values.has_started === "yes"
        ? messages.has_started
        : messages.has_not_started,
      error: !!error,
    });
  }

  const handleApproverEmailValueChange = React.useCallback(
    (name: string, value: string) => {
      form.set(Form.target.VALUES, {
        approverEmail: value,
      });
      form.set(Form.target.ERRORS, {
        approverEmail: undefined,
      });
      validate([name, value]).then(([name, error]) => handleMessage(error));
      if (prev.form_values?.approverEmail !== form.values.approverEmail && !! approverEmail_error) {
        setMessage({ text: messages.user_id_not_found, error: true });
      }
    },
    [form, handleMessage, prev.form_values, approverEmail_error, validate]
  );

  function getDirectoryOptions(): string[] {
    return directory_approverEmails ? directory_approverEmails.map((user) => user.email) : [];
  }

  function validate([name, value]: [string, any]): Promise<
    [keyof Data, Error?]
  > {
    let error: Error | undefined;

    switch (name) {
      case "approverEmail":
        error =
          Form.Validators.hasValue(value) || Form.Validators.isEmail(value);
        break;
    }

    return Promise.resolve([name as keyof Data, error]);
  }

  return (
    <Form>
      <Form.Textbox
        label="VIP Email"
        name="vipEmail"
        onChange={onHandleChange}
        size={12}
        value={form.values.vipEmail}
        error={form.errors.vipEmail}
        maxLength={80}
        disabled={true}
      />
      <Form.Autocomplete
        error={form.errors.approverEmail}
        label="Approver Email"
        loading={directory_approverEmails_fetching}
        name="approverEmail"
        onChange={handleApproverEmailValueChange}
        onInput={handleApproverEmailValueInput}
        options={getDirectoryOptions()}
        size={12}
        value={form.values.approverEmail}
        required={true}
      />
      <Form.Checkbox
        label="Active"
        name="active"
        onChange={onHandleChange}
        size={6}
        value={form.values.active}
      />
    </Form>
  );
};
